import { TrackList } from '@/components/TrackList';
import { useScrollTop } from '@/hooks/useScrollTop';
import { StyleFilterArtistDetail } from '@/service/type/Filter';
import { useTrackLists } from '@/state/style-filter-list-store';
import { useRef } from 'react';
import FilterCards from './FilterCards';
import { MarketArtiestHeader } from './MarketArtiestHeader';
import PlayerCard from './PlayerCard';
import { Profile } from './Profile';
import { useRequest } from 'ahooks';
import { getStyleFilterGroupList } from '@/service/filter';

export default function ArtiestFilters({ data }: { data?: StyleFilterArtistDetail }) {
  const { marketAudioListData } = useTrackLists();
  const playerCardRef = useRef<HTMLDivElement>(null);
  const trackListRef = useRef<HTMLDivElement>(null);
  const { componentRef } = useScrollTop();

  const { data: getStyleFilterGroupData } = useRequest(getStyleFilterGroupList);

  return (
    <div className="min-h-screen bg-[#F6F6F7]" ref={componentRef}>
      {/* <Navbar /> */}
      <MarketArtiestHeader data={data} />
      <div className="px-32 pb-12">
        <Profile playerCardRef={playerCardRef} trackListRef={trackListRef} />
      </div>
      <div className="ml-32 pb-12">
        <FilterCards getStyleFilterGroupData={getStyleFilterGroupData} />
      </div>
      <div className="px-32 pb-12" ref={playerCardRef}>
        <PlayerCard />
      </div>
      <div className="px-32 pb-12" ref={trackListRef}>
        <section className="p-8 bg-white rounded-2xl">
          <h2 className="text-[32px] text-[#48484b] tracking-[-0.96px] leading-10 mb-6">
            Tracks Jenerated with
            <div>
              <span>Imogen Heap </span>StyleFilters™
            </div>
          </h2>
          <TrackList
            trackListData={marketAudioListData['IMO-HEADLOCK']}
            label={{ title: 'Title', creator: 'User', filter: 'StyleFilter' }}
          />
        </section>
      </div>
    </div>
  );
}
